import { useNavigate } from "react-router";
import { IconXmarkLine } from "@hamlak/ui";
import { t } from "@/i18n/ko";
import "./auth.css";

/**
 * 온보딩 3화면(F01-03·07·05) 우상단 X(AC0-259, 시안 TopNavigation right 슬롯). 누르면 홈으로 이탈한다.
 * 세션 정리(로그아웃·스낵바)는 온보딩 라우트를 벗어날 때 AppShell 이 abandonOnboarding 으로 한 번만 처리한다(AC0-149).
 */
export function OnboardingCloseButton() {
  const navigate = useNavigate();
  return (
    <button type="button" className="auth__navButton" aria-label={t("common.close")} onClick={() => navigate("/home", { replace: true })}>
      <IconXmarkLine />
    </button>
  );
}
